<template>
  <main class="page document-page">
    <div class="document-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home' }">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'documents' }">Документы</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ title }}</span>
        </li>
      </ul>
      <h1 class="document-page__title">{{ title }}</h1>
      <div class="document-page__content">
        <div class="document-page__search" v-if="$store.state.documents && $store.state.documents.length">
          <i class="document-page__search__icon" aria-hidden="true">
            <search-icon/>
          </i>
          <input class="document-page__search__input" type="text" autocomplete="off" title="Поиск по заголовку и названию документа" placeholder="Поиск по заголовку и названию документа" v-model="search"/>
        </div>
        <div class="document-page__table" v-if="$store.state.documents && $store.state.documents.length">
          <div class="document-page__table__header">
            <span>Название документа</span>
            <span>Дата публицации</span>
          </div>
          <ul class="document-page__table__body">
            <li class="document-page__table__item" v-for="(document, index) in documents" :key="index">
              <router-link :to="{ name: 'documentsShow', params: { cat_id: document.category_id, id: document.id} }">
                <h2>{{ document.title }}</h2>
              </router-link>
              <time :datetime="document.date_publication | robotDate">{{ document.date_publication | humanDate }}</time>
            </li>
          </ul>
        </div>
        <span v-else class="document-page__empty">Материалы отсутствуют</span>
      </div>
    </div>
  </main>
</template>

<script>
import SearchIcon from 'components/svg/SearchIcon.vue'

export default {
  async asyncData ({ store, route }) {
    await store.dispatch('DOCUMENTS_OPEN_PAGE', route.params.id)
  },
  name: 'DocumentsOpenPage',
  components: { SearchIcon },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    title () {
      const categories = this.$store.state.categories.filter(item => item.id === parseInt(this.$route.params.id))
      return categories[0] ? categories[0].title : ''
    },
    documents () {
      return this.$store.state.documents.filter(item => item.title.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      this.title,
      'управление образования, образование',
      '',
      this.title,
      '',
      ''
    )
  }
}
</script>
